// Formatos e leitura de preço usados pela lista de cotações e pela cotação aberta.
export const fmtQtd = (n) => Number(n || 0).toLocaleString('pt-BR', { maximumFractionDigits: 3 });
export const un = (u) => (String(u || '').toUpperCase() === 'M2' ? 'm²' : String(u || 'un').toLowerCase());
// o SQL Server devolve DATETIME2 sem fuso (hora de Brasília lida como UTC): mostra os campos como vieram
export const fmtDataHora = (s) => { const t = String(s || ''); return t ? `${t.slice(8, 10)}/${t.slice(5, 7)} ${t.slice(11, 16)}` : '—'; };
// R$ com 2 casas; só passa de 2 se o fornecedor digitou mais (o banco guarda 4)
export const precoTxt = (v) => (v == null ? '' : Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }));
export const moeda = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
// Aceita "12,50", "1.250,00" e também "12.50": sem vírgula, um ponto só é a casa decimal (12.50 virava 1.250 — 30/10).
export const paraNumero = (s) => {
  let t = String(s ?? '').replace(/[R$\s]/g, '');
  if (!t) return null;
  if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3}){2,}$/.test(t)) t = t.replace(/\./g, '');
  const n = /^\d*\.?\d+$/.test(t) ? Number(t) : NaN;
  return Number.isFinite(n) ? n : NaN;
};
// Digitação no padrão de banco (30/10): os dígitos entram pela direita, sempre 2 casas — 5 → 0,05; 50 → 0,50; 500 → 5,00.
// Só olha os dígitos (o que não é número some); zero vira vazio (= não cotar). Teto de 10 dígitos (99.999.999,99).
export const digitarBanco = (s) => {
  const d = String(s ?? '').replace(/\D/g, '').replace(/^0+/, '').slice(0, 10);
  return d ? (Number(d) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
};
// Nome como "Lucas" em vez de "LUCAS"
export const nomeBonito = (s) => String(s || '').toLowerCase().replace(/(^|[\s.])\p{L}/gu, (m) => m.toUpperCase());

export const Situacao = ({ c }) => {
  if (!c.aberta) return <span className="badge badge-neutro" title="O Centrão encerrou esta cotação"><i className="bi bi-lock" />Encerrada</span>;
  if (c.situacao === 'respondido') {
    const parcial = c.com_preco != null && c.itens != null && Number(c.com_preco) < Number(c.itens);
    return parcial
      ? <span className="badge badge-pendente" title="Respondida, mas ainda há produtos sem preço">Respondida {c.com_preco}/{c.itens}</span>
      : <span className="badge badge-positivo"><i className="bi bi-check2" />Respondida</span>;
  }
  return <span className="badge badge-pendente">Aguardando sua resposta</span>;
};
